import { CircularProgress, CircularProgressProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { ReactElement, ReactNode } from "react";

export type LoadingProps = {
  size?: number;
  message?: ReactNode | string;
  style?: React.CSSProperties;

  /** If we know the progress of what we're loading, specify this (between 0 and 1) */
  progress?: number;
  progressProps?: CircularProgressProps;
};

export default function Loading({
  size = 100,
  message = null,
  progress = 0,
  style = {},
  progressProps: passedProgressProps = {},
}: LoadingProps): ReactElement {
  const theme = useTheme();

  const progressProps: CircularProgressProps = {
    size,
    thickness: 1,
    ...passedProgressProps,
  };
  if (progress) {
    progressProps.variant = "determinate";
    progressProps.value = progress * 100;
  }

  return (
    <div
      style={{
        marginTop: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        ...style,
      }}
    >
      <CircularProgress {...progressProps} />
      {message ? <p style={{ textAlign: "center" }}>{message}</p> : null}
    </div>
  );
}

export function FullPageLoading(): ReactElement {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Loading />
    </div>
  );
}
